var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgGearinline = function SvgGearinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M495 316l-54-41 2-25-2-25 54-41c5-3 7-10 3-16l-51-86c-3-6-10-8-16-6l-64 25c-13-9-27-18-43-24l-10-66c-1-6-6-11-13-11H199c-7 0-12 5-13 11l-10 66c-16 6-30 15-43 24L69 76c-6-2-13 0-16 6L2 168c-4 6-2 13 3 16l54 41-2 25 2 24-54 42c-5 4-7 10-3 16l51 86c3 6 10 8 16 6l64-25c13 10 27 18 43 24l10 67c1 6 6 10 13 10h102c7 0 12-4 13-10l10-67c16-6 30-14 43-24l64 25c6 2 13 0 16-6l51-86c4-6 2-12-3-16zm-111-21l54 39-19 33-63-26c-19 22-46 38-77 44l-9 65h-40l-9-65c-31-6-58-22-77-44l-63 26-19-33 54-39c-10-29-10-61 0-90l-54-39 19-32 62 26c20-22 47-38 78-45l10-65h38l10 66c31 6 58 22 78 44l62-26 19 32-54 39c10 29 10 61 0 90z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M250 150c-57 0-103 45-103 100s46 100 103 100 103-45 103-100-46-100-103-100zm0 150c-28 0-51-22-51-50s23-50 51-50 51 22 51 50-23 50-51 50z"
  })));
};

export default SvgGearinline;